import React, { useEffect } from 'react';

const FaviconChanger = () => {
  useEffect(() => {
    const favicon = document.getElementById('favicon');
    const faviconapple = document.getElementById('faviconapple');
    const currentUrl = window.location.href;

    // Function to update the favicon
    const updateFavicon = (url) => {
      if (url.includes('sweatpilates.in')) {
        favicon.href = 'https://sweatpilates.in/wp-content/uploads/2023/03/Logo_BPC_Sweat_new-removebg-preview-1-1-150x150.png';
        faviconapple.href = 'https://sweatpilates.in/wp-content/uploads/2023/03/Logo_BPC_Sweat_new-removebg-preview-1-1-150x150.png';
      } else if (url.includes('bodyprocoachbootcamp.com')) {
        favicon.href = 'https://bodyprocoachbootcamp.com/wp-content/uploads/2023/07/Frame-71.png';
        faviconapple.href = 'https://bodyprocoachbootcamp.com/wp-content/uploads/2023/07/Frame-71.png';
      }
    };

    // Initial call to set favicon based on current URL
    updateFavicon(currentUrl);

    // Listen for changes in URL and update favicon accordingly
    const handleUrlChange = () => {
      const newUrl = window.location.href;
      updateFavicon(newUrl);
    };

    window.addEventListener('popstate', handleUrlChange);

    return () => {
      window.removeEventListener('popstate', handleUrlChange);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default FaviconChanger;
